// extracted by mini-css-extract-plugin
export default {"contentDescription":"styles_contentDescription__q-jac"};